import { jsx as _jsx } from "react/jsx-runtime";
import { Conditional } from '../conditional';
import { CatIconChevronDown } from '@blocks-react/components/Icons/ChevronDown';
import { CatIconChevronUp } from '@blocks-react/components/Icons/ChevronUp';
import styles from './styles.module.scss';
export const Expander = ({ isExpanded, onExpandHandler, className }) => {
    const chevronUpIcon = (_jsx(CatIconChevronUp, { onClick: onExpandHandler, className: styles['expander-icon'], size: "lg", "data-testid": "expander-icon-close" }));
    const chevronDownIcon = (_jsx(CatIconChevronDown, { onClick: onExpandHandler, className: styles['expander-icon'], size: "lg", "data-testid": "expander-icon-open" }));
    return (_jsx("div", { className: `${styles['expander-icon']} ${className}`, children: _jsx(Conditional, { test: isExpanded, fallback: chevronDownIcon, children: chevronUpIcon }) }));
};
